import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { AuthService } from "../../../services";
import { CustomerService } from "../../../services";
import { Subscription } from "rxjs";
import { WebCustomer } from "../../../models";
import { filter } from "rxjs/operators";

@Component({
  selector: "app-user-menu",
  templateUrl: "./user-menu.component.html",
  styleUrls: ["./user-menu.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class UserMenuComponent implements OnInit, OnDestroy
{

  private customerSubscription: Subscription;
  public customer: WebCustomer;

  constructor(
    private authService: AuthService,
    private customerService: CustomerService,
  ) { }

  ngOnInit()
  {
    this.customerSubscription = this.customerService.customer.subscribe(customer =>
    {
      this.customer = customer;
    });
  }

  ngOnDestroy()
  {
    this.customerSubscription?.unsubscribe();
  }

  logOutUser()
  {
    this.authService.logout();
    this.customerService.clearCustomerData();
  }

}
